import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, OutlinedInput, Select, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { displayFullName } from "../../../../utilities/formatters";

import { getSurveyTypes, getFacilitators } from "../../../../reducers";
import msfActions from "../../../../actions/msfActions";


function SurveyForm(props) {
    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
            <DialogTitle>{props.dialogTitle}</DialogTitle>
            <DialogContent dividers={false}>
                <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                    {!!props.newSurvey && !props.types.length
                        ? <Typography>Cannot create survey</Typography>
                        : (
                            <Box
                                component="form"
                                autoComplete="off"
                                noValidate
                                className="dialog-content"
                            >
                                <FormControl component="div" margin="normal" fullWidth >
                                    <InputLabel id="label-title" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                                        Title
                                    </InputLabel>
                                    <OutlinedInput
                                        id="text-title"
                                        value={props.title}
                                        onChange={({target}) => props.setTitle(target?.value)}
                                    />
                                </FormControl>
                                {!!props.newSurvey && props.types && (
                                    <FormControl component="div" margin="normal" fullWidth>
                                        <InputLabel id="label-type" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                                            Type
                                        </InputLabel>
                                        <Select
                                            id="select-type"
                                            value={props.type}
                                            onChange={({target}) => props.setType(target.value)}
                                        >
                                            {props.types.map((option) => (
                                                <MenuItem key={option.ref} value={option.ref}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                                {!!props.facilitators && (
                                    <FormControl component="div" margin="normal" fullWidth>
                                        <InputLabel id="label-facilitator" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                                            Facilitator
                                        </InputLabel>
                                        <Select
                                            id="select-facilitator"
                                            value={props.facilitator}
                                            onChange={({target}) => props.setFacilitator(target.value)}
                                        >
                                            {props.facilitators.map((option) => (
                                                <MenuItem key={option.uuid} value={option.uuid}>
                                                    {displayFullName(option)}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </Box>
                        )
                    }

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={props.onSave}
                    disabled={!props.type}
                >
                    {props.buttonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function SurveyFormDialog({ open, onClose, data = null }) {
    const dispatch = useDispatch();
    const appCode = 'P-MSF';
    const newSurvey = !data?.uuid;

    useEffect(() => {
        dispatch(msfActions.getFacilitators(appCode));
        if (newSurvey) {
            dispatch(msfActions.getSurveyTypes(appCode));
        }
    }, [dispatch]);

    const types = useSelector(getSurveyTypes) || [];
    const facilitators = useSelector(getFacilitators) || [];

    const [title, setTitle] = useState(data?.title || '');
    const [type, setType] = useState(data?.type.ref || '');
    const [facilitator, setFacilitator] = useState(data?.facilitator?.uuid || '');

    const params = {
        title,
        type: { ref: type },
        facilitator: facilitators.find(({uuid}) => uuid === facilitator)
    };

    const onSave = () => {
        if (newSurvey) {
            dispatch(msfActions.addSurvey(appCode, params));
        } else {
            dispatch(msfActions.updateSurvey(appCode, data.uuid, params));
        }
        onClose();
    };

    return (
        <SurveyForm
            open={open}
            newSurvey={newSurvey}
            dialogTitle={newSurvey ? 'New survey' : 'Edit survey'}
            buttonLabel={newSurvey ? 'Add' : 'Save'}
            onClose={onClose}
            onSave={onSave}
            title={title}
            setTitle={setTitle}
            type={type}
            setType={setType}
            types={types}
            facilitator={facilitator}
            setFacilitator={setFacilitator}
            facilitators={facilitators}
        />
    );
}

export default SurveyFormDialog;
